module.exports = __webpack_public_path__ + "img/4-1.f43f4c34.png";